import { render, staticRenderFns } from "./SchemaExampleConfig.vue?vue&type=template&id=f1a13f92"
import script from "./SchemaExampleConfig.vue?vue&type=script&lang=js"
export * from "./SchemaExampleConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports